module.exports = __webpack_public_path__ + "img/sort-down.083f2d71.svg";